<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/cartloader";
import { ModelListSelect } from "vue-search-select";
import { mapActions, mapGetters, mapState } from "vuex";
import Swal from "sweetalert2";
import moment from "moment";
/**
 * Form Layouts component
 */
export default {
  page: {
    title: "New Usage",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, ModelListSelect,Loader, },
  data() {
    return {
      title: "Use Consumables",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "New Usage",
          active: true,
        },
      ],
      selected: null,
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "item_name",
          sortable: true,
          label: "ITEM",
        },
        {
          key: "quantity",
          sortable: true,
          label: "QUANTITY",
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      existingItem: [],
      unitsArr: [],

      // Value from user input for adding position
      data: {
        product: "",
        quantity: "",        
        unit: "1",        
        unit_price: "", 
        store:""       
      },
      itemError: "",
      quantityError: "",
      unitError:"",
      totals: {
        date:moment(new Date()).format("YYYY-MM-DD"), 
        product:"",
        given_to:"",
        reason: "",
        category:0,
        store:""
      },
      // edit item
      editdata: {
        id: "",
        name: "",
        quantity: ""
      },
      // delete item
      deletedata: {
        name: "",
        id: "",
      }
    };
  },

  computed: {
    // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
    ]),
    ...mapGetters("consumables", ["SaveStatus","Consumables", "ConsumablesUsageCart"]),
    ...mapGetters("auth",["MyUserPerm"]),
    ...mapGetters("sales", ["Products"]),
    ...mapGetters("setting", ["BusinessSettings","GeneralSettings"]),
    ...mapGetters("store", ["Stores","StoreStock"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.ConsumablesUsageCart ? this.ConsumablesUsageCart.length : 1;
    },

    formattedUnitsArr() {
      return (this.unitsArr || []).map(item => {
        return {
          ...item,
          option_text: item.unit?.symbol || '' // flatten it
        };
      });
    }

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.ConsumablesUsageCart ? this.ConsumablesUsageCart.length : 1;
  },
  watch: {
    show(newValue) {
      // Do whatever makes sense now
      if (newValue) {
        if (this.type == "success") {
          this.closeModal(this.modal_id);
          this.resetTotals();
          Swal.fire("Success!", this.message.msg, "success");
          // this.$toast.success(this.message.msg);
        } else {
          // this.$toast.error(this.message.msg);
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
    ConsumablesUsageCart(newValue) {
      if (newValue && newValue.length > 0) {
        this.totals.date = newValue[0].date ?? "";
        this.totals.reason = newValue[0].reason ?? "";
        this.totals.givenTo = newValue[0].givenTo ?? "";
      } else if (!newValue || newValue.length === 0) {
        this.resetTotals();
      }
    }
  },
  methods: {
    ...mapActions({
      FetchConsumables: "consumables/fetchConsumables",
      FetchConsumablesUsageCart: "consumables/fetchConsumablesUsageCart",
      AddCart: "consumables/addToConsumableUsageCart",
      DeleteCartItem: "consumables/deleteConsumableUsageCart",
      EditCartItems: "consumables/editConsumableUsageCart",
      SaveUsage: "consumables/addConsumableUsage",
      FetchItems: "sales/fetchItems",
      FetchGeneralSettings: "setting/fetchGeneralSettings",
      FetchSettings: "setting/fetchBusinessSettings",
      FetchStoreStock: "store/fetchStoreStock",
      FetchStores: "store/fetchStores",
    }),

    // COMMA SEPERATORS
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
            .toString()
            .replace(/[^0-9.]+/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    checkItem() {
      this.existingItem = this.ConsumablesUsageCart.filter((item) => {
        return item.item_id == this.data.product && item.givenTo == this.data.given_to;
      });
      if (this.existingItem.length) {
        this.itemError = "This Item exists already in cart for "+this.data.given_to;
      } else {
        this.itemError = "";
      }
    },

    assignArr(){
        if(this.data.store==''){
          let selectedPdt = this.Consumables.filter((product)=>{
              return product.id == this.data.product;
          })
          this.unitsArr = selectedPdt[0].units;        
          this.data.unit = this.unitsArr[0].id; 
        }else{
          let selectedPdt = this.StoreStock.filter((product)=>{
              return product.id == this.data.product;
          })
          this.unitsArr = selectedPdt[0].units;
          this.data.unit = this.formattedUnitsArr[0].id;
        }
    },

    resetData() {
      this.data.product = ""; 
      this.data.quantity = "";
      this.data.unit = "";
      this.data.store = "";
    },
    resetTotals() {
      this.totals.product = "";
      this.totals.given_to = "";
      this.totals.reason = "";
      this.totals.store = "";
    },
    resetDeleteItem(modalId) {
      this.closeModal(modalId);
      this.deletedata.name = "";
      this.deletedata.id = "";
      this.modal_id = "";
    },
    resetEdit(modalId) {
      this.closeModal(modalId);
      this.editdata.id = "";
      this.editdata.quantity = "";
      this.modal_id = "";
    },

    resetErrors() {
      this.itemError = "";
      this.quantityError = "";
      this.unitError = "";
    },

    showEditModal(data) { 
      this.editdata.name = data.item_name;
      this.editdata.id = data.id;
      this.editdata.quantity = data.quantity;
    },

    showDeleteModal(data) {
      this.deletedata.name = data.item_name;
      this.deletedata.id = data.id;
    },
    editItem(modalId) {
      this.modal_id = modalId;
      this.EditCartItems(this.editdata);
    },

    deleteItem(modalId) {
      this.modal_id = modalId;
      this.DeleteCartItem(this.deletedata);
    },
    saveUsage() {
      this.SaveUsage(this.totals);      
    },
    addToCart() {
      if (this.data.product == "") {
        this.itemError = "Product is required";
        return;
      } else {
        this.itemError = "";
      }
      if (this.data.quantity == "") {
        this.quantityError = "Quantity field is required";
        return;
      } else {
        this.quantityError = "";
      }      
      if (this.existingItem.length) {
        this.itemError = "This Item exists already please";
        return;
      } else {
        this.itemError = "";
      }
      if (this.data.unit == "") {
        this.unitError = "Item unit is required";
        return;
      } else {
        this.unitError = "";
      }
      this.AddCart(this.data);
    },

    // Fetch store stock
    fetchStoreStock(){
      if(this.data.store!=''){
        let data = {
          id:this.data.store
        };  
        this.FetchStoreStock(data);        
      }else if(this.totals.store!=''){
        let data = {
          id:this.totals.store
        }; 
        this.FetchStoreStock(data);  
      }          
    },

    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
        this.resetData();
        this.resetErrors();
      });    
    }
  },
  created() {
    this.FetchConsumables();
    this.FetchConsumablesUsageCart();
    this.FetchItems();
    this.FetchGeneralSettings();
    this.FetchSettings();
    this.FetchStores();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-md-8">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Items in Cart</h4>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  class="datatables"
                  :items="ConsumablesUsageCart ? ConsumablesUsageCart : []"
                  :fields="fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(total_price)="data">
                  {{
                    data.item.unitprice
                        ? thousandSeprator(data.item.unitprice * data.item.quantity)
                        : 0
                  }}
                </template>

                <template #cell(unit_price)="data">
                  {{ data.item.unit_price ? thousandSeprator(data.item.unit_price) : 0 }}
                </template>
                <template #cell(quantity)="data">
                  {{ data.item ? data.item.quantity : 0 }} {{data.item.unit.name}}
                </template>

                <template #cell(actions)="data">
                  <b-button
                      size="sm"
                      variant="primary"
                      v-b-modal.edit-item-modal
                      class="m-2"
                      @click="showEditModal(data.item)"
                  ><i class="fa fa-edit"></i></b-button
                  >
                  <b-button
                      v-b-modal.delete-item-modal
                      variant="danger"
                      size="sm"
                      @click="showDeleteModal(data.item)"
                  ><i class="fa fa-trash"></i></b-button
                  >
                </template>
              </b-table>

              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination
                          v-model="currentPage"
                          :total-rows="rows"
                          :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <Loader v-if="!ConsumablesUsageCart" />

            <b-form>              
              <div class="row mt-4" v-if="ConsumablesUsageCart && ConsumablesUsageCart.length>0">
                <div class="form-group col-md-4 mb-3" v-if="BusinessSettings?BusinessSettings.store==1:false">
                  <label>Destination<span class="text-danger">*</span></label>
                  <select
                      type="text"
                      class="form-control"
                      v-model="totals.category"
                      placeholder="Select Destination"
                  >
                    <option value="0">Stock</option>
                    <option value="1">Store</option>
                  </select>
                </div>
                <div class="form-group col-md-4 mb-3" v-if="totals.category==1 && GeneralSettings.multiple_stores == 1">
                  <label>To Store</label>
                  <model-list-select
                      :list="[...(Stores || []), { id: '', name: 'General Store' }]"
                      v-model="totals.store"
                      option-value="id"
                      option-text="name"
                      placeholder="Select Store"
                      @input="fetchStoreStock()"
                  >
                  </model-list-select>
                </div> 
                <div class="form-group col-md-4 mb-3" v-if="GeneralSettings.use_ingredients == 1">
                  <label>Output</label>
                  <model-list-select
                      v-if="totals.store==''"
                      :list="Products ? Products : []"
                      v-model="totals.product"
                      option-value="id"
                      option-text="name"
                      placeholder="Select Product"
                  >
                  </model-list-select>
                  <model-list-select
                      v-else
                      :list="StoreStock ? StoreStock : []"
                      v-model="totals.product"
                      option-value="id"
                      option-text="product_name"
                      placeholder="Select Product"
                  >
                  </model-list-select>
                </div>
                <div class="form-group col-md-4 mb-3">
                  <label>Date</label>
                  <input
                      type="date"
                      class="form-control"
                      v-model="totals.date"
                      placeholder="Enter Date"
                      v-limit-future-date
                  />
                </div>
                <div class="form-group col-md-4 mb-3">
                  <label>Given To</label>
                  <input
                      type="text"
                      class="form-control"
                      step="any"
                      v-model="totals.given_to"
                      @input="resetErrors()"
                      placeholder="Enter the receiver"
                  />
                </div>
                <div class="form-group col-md-4 mb-3">
                  <label>Reason</label>
                  <textarea
                      type="text"
                      class="form-control"
                      step="any"
                      v-model="totals.reason"
                      @input="resetErrors()"                      
                      placeholder="Enter the reason"
                  ></textarea>
                </div>
                <div v-if="MyUserPerm.using_consumables == 1" class="col-md-4 mt-4">
                  <b-button variant="primary" class="pull-center" @click="saveUsage()"
                  ><i class="fa fa-check"></i> Save Usage
                    <b-spinner
                        v-if="SaveStatus"
                        variant="light"
                        label="Spinning"
                    ></b-spinner>
                  </b-button>
                </div>
              </div>
            </b-form>
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <div class="card">
          <div class="card-body">
            <form action="">
              <div class="form-group mb-3" v-if="GeneralSettings.multiple_stores == 1">
                <label>From Store</label>
                <model-list-select
                    :list="Stores ? Stores : []"
                    v-model="data.store"
                    option-value="id"
                    option-text="name"
                    placeholder="Select Store"
                    @input="fetchStoreStock()"
                >
                </model-list-select>
              </div>
              <div class="form-group mb-3">
                <label>Input Product <span class="text-danger">*</span></label>
                <model-list-select
                    v-if="data.store !=''"
                    :list="StoreStock ? StoreStock : []"
                    v-model="data.product"
                    option-value="id"
                    option-text="name"
                    placeholder="Select Product"
                    @input="resetErrors(), checkItem(), assignArr()"
                >
                </model-list-select>
                <model-list-select
                    v-else
                    :list="Consumables ? Consumables : []"
                    v-model="data.product"
                    option-value="id"
                    option-text="nameto_select"
                    placeholder="Select Product"
                    @input="resetErrors(), checkItem(), assignArr()"
                >
                </model-list-select>
                <div class="text-danger" v-if="itemError">
                  <em>{{ itemError }}</em>
                </div>
              </div>
              <div class="form-group mb-3">
                  <label>Unit Measure <span class="text-danger">*</span></label>
                  <model-list-select
                  v-if="data.store==''"
                  :list="unitsArr ? unitsArr : []"
                  v-model="data.unit"
                  option-value="id"
                  option-text="unitsym"
                  placeholder="Select Unit"
                  @input="resetErrors()"
                  >
                  </model-list-select>
                  <model-list-select
                  v-else
                  :list="formattedUnitsArr"
                  v-model="data.unit"
                  option-value="id"
                  option-text="option_text"
                  placeholder="Select Unit"
                  @input="resetErrors()"
                  >
                  </model-list-select>
                  <div class="text-danger" v-if="unitError">
                  <em>{{ unitError }}</em>
                  </div>
              </div>
              <div class="form-group mb-3">
                <label>Quantity <span class="text-danger">*</span></label>
                <input
                    type="number"
                    class="form-control"
                    step="any"
                    v-model="data.quantity"
                    @input="resetErrors()"
                    @keyup.enter="addToCart()"
                    placeholder="Enter Quantity"
                />
                <div class="text-danger" v-if="quantityError">
                  <em>{{ quantityError }}</em>
                </div>
              </div>              
              <div class="form-group text-center">
                <b-button
                    @click="addToCart()"
                    variant="primary"
                ><i class="fa fa-plus"></i> Add
                  <b-spinner
                      v-if="SaveStatus"
                      variant="light"
                      small
                      label="Spinning"
                  ></b-spinner>
                </b-button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!-- modal edit item starts -->
    <b-modal id="edit-item-modal" hide-footer @hidden="resetEdit()" class="text-primary">
      <template #modal-title>
        Edit Item {{ editdata.name }}</template
      >
      <div class="form-group mb-3">
        <label>Quantity</label>
        <input
            type="number"
            class="form-control"
            step="any"
            v-model="editdata.quantity"
        />
      </div>      
      <div class="modal-footer">
        <button
            type="button"
            class="btn btn-danger"
            data-dismiss="modal"
            @click="closeModal('edit-item-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
            type="button"
            class="btn btn-primary"
            @click="editItem('edit-item-modal')"
        >
          <i class="fa fa-check"></i> Save Changes
          <b-spinner
              v-if="SaveStatus"
              variant="light"
              small
              label="Deleting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
    <!-- modal delete expense starts -->
    <b-modal id="delete-item-modal" hide-footer @hidden="resetDeleteItem" class="text-danger">
      <template #modal-title> Delete {{ deletedata.name }}</template>
      <div class="form-group mb-3">
        <div class="input-group">
          <h5>Do you want to remove this item from cart? Click Proceed to continue.</h5>
        </div>
      </div>
      <div class="modal-footer">
        <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="closeModal('delete-item-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
            type="button"
            class="btn btn-danger"
            @click="deleteItem('delete-item-modal')"
        >
          <i class="fa fa-trash"></i> Proceed
          <b-spinner
              v-if="SaveStatus"
              variant="light"
              small
              label="Deleting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
    <!--  end row -->
  </Layout>
</template>
<style>
.btn-primary, .page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>